import { translate } from 'react-translate'
import { connect } from 'react-redux'
import DeviceAssignedSite from './device-assigned-site'
export default translate('DeviceSerial')(connect(
)(DeviceAssignedSite))
